import React from 'react';
import { StackScreen, Typography, ScrollView, Flex } from '@banhala/ui-kit';

export const CategoryScreen: React.FC = () => {
  return (
    <StackScreen title={'카테고리'} hideBackButton={true}>
      <ScrollView style={{ flex: 1 }}>
        <Flex height={500} alignItems={'center'} justifyContent={'center'}>
          <Typography>CATEGORY_SCREEN</Typography>
        </Flex>
      </ScrollView>
    </StackScreen>
  );
};
